
  import { defineComponent } from "vue";

  export default defineComponent({
    name: "CardFooter",

    props: {
      bordered: {
        type: Boolean,
        required: false,
        default: () => true,
      }
    },
  });
